import React,{useEffect,useState} from 'react'
import { useLocation } from 'react-router-dom';
import './ContactUs.css'
import banner from '../../assets/images/contact us banner.png'
import aos from 'aos';
import 'aos/dist/aos.css'
import axios from 'axios';


const ContactUs = () => {
  const [formData,setFormData]=useState({name:"",email:"",phone:"",message:""});
 

  const handleChange=(e)=>{
    const {name,value}=e.target;
    setFormData({
      ...formData,
      [name]:value
    });
  };

  
  


  
  const handleSubmit=async (e)=>{
    e.preventDefault();
    try{

      const [response1] = await Promise.all([
        axios.post('http://localhost:4000/api/contact',formData),
        axios.post('http://localhost:4000/send-email',formData)
      ]);

      setFormData({name:"",email:"",phone:"",message:""})
        alert(response1.data.message)
      
    }
    catch(error){
      console.error('Error sending message:', error);
      alert(error);
    }
  
  }


  const { top } = useLocation();
  useEffect(() => {
    aos.init({ duration: 1000 });
    window.scrollTo(0,0);
  }, [top]);



  return (
    <>
      <div className="container-fluid gx-0">
        <div className="row gx-0">
          <img className='img-fluid' data-aos="zoom-in" src={banner} alt="" />
        </div>
      </div>
      <div className="container py-lg-5 py-3">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="address" data-aos="zoom-in">
              <i className="bi bi-geo-alt"></i>
              <p className='pe-lg-3'><span>Address:</span><br /> Oreus Life Sciences Private Limited 99-B, Mayur Vihar, Phase-1, New Delhi-110 091</p>
            </div>
            <div className="address" data-aos="zoom-in">
              <i className="bi bi-telephone"></i>
              <p><span>Phone:</span><br />+91 97600 11544<br /> +91 75000 82082</p>
            </div>
            <div className="address" data-aos="zoom-in">
              <i className="bi bi-envelope"></i>
              <p><span>Email:</span><br />oreuslife@gmail.com</p>
            </div>
          </div>


          <div className="col-lg-6 col-md-6">
            <div className="contact-us">
              <h4 className='contact-us-form-heading' data-aos="zoom-in">Write Us Your Enquiry...</h4>
              <form onSubmit={handleSubmit} data-aos="zoom-in">
                <div className="mb-3">
                  <label htmlFor="name">Name:</label>
                  <input 
                  required
                  type="text" 
                  name='name' 
                  value={formData.name} 
                  onChange={handleChange} 
                  className='form-control' />
                </div>

                <div className="mb-3">
                  <label htmlFor="email">Email:</label>
                  <input 
                  required
                  type="email" 
                  name='email' 
                  value={formData.email} 
                  onChange={handleChange} 
                  className='form-control' />
                </div>

                <div className="mb-3">
                  <label htmlFor="phone">Phone Number:</label>
                  <input 
                  required
                  type="number" 
                  name='phone' 
                  value={formData.phone} 
                  onChange={handleChange} 
                  className='form-control' />
                </div>

                <div className="input-group">
                  <span className="input-group-text">Message</span>
                  <textarea required className="form-control" name='message' value={formData.message} onChange={handleChange}  aria-label="With textarea"></textarea>
                </div>
                <div className='text-end'>
                  <input type='submit' className='btn btn-success my-3' />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ContactUs
